module.exports = __webpack_public_path__ + "img/spec-en.da043cb9.jpg";